import styled from 'styled-components';
import { Row, type RowProps } from 'antd';

interface LoadMoreProps extends RowProps {
  type?: string;
}

// eslint-disable-next-line import/prefer-default-export
export const LoadMoreRow = styled(Row)<LoadMoreProps>`
  margin-top: 18px;
  margin-bottom: 18px;
`;
